export function BookMark() {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
      <rect x="6" y="10" width="44" height="48" rx="3" fill="var(--tp-accent3)" stroke="var(--tp-ink)" strokeWidth="3" />
      <rect x="12" y="6" width="44" height="48" rx="3" fill="var(--tp-accent)" stroke="var(--tp-ink)" strokeWidth="3" />
      <path d="M 22 22 L 46 22 M 22 30 L 42 30 M 22 38 L 38 38" stroke="white" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}

export function GoogleIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20">
      <path d="M19.6 10.23c0-.68-.06-1.34-.18-1.97H10v3.72h5.38a4.6 4.6 0 0 1-2 3.02v2.51h3.23c1.89-1.74 2.99-4.3 2.99-7.28z" fill="#fff" />
      <path d="M10 20c2.7 0 4.96-.9 6.61-2.43l-3.23-2.51c-.9.6-2.04.96-3.38.96-2.6 0-4.8-1.76-5.59-4.12H1.07v2.59A9.99 9.99 0 0 0 10 20z" fill="#fff" opacity="0.85" />
      <path d="M4.41 11.9a6 6 0 0 1 0-3.8V5.51H1.07a10 10 0 0 0 0 8.98l3.34-2.59z" fill="#fff" opacity="0.65" />
      <path d="M10 3.96c1.47 0 2.78.51 3.82 1.5l2.85-2.84A9.96 9.96 0 0 0 10 0a9.99 9.99 0 0 0-8.93 5.51L4.4 8.1C5.2 5.74 7.4 3.96 10 3.96z" fill="#fff" opacity="0.5" />
    </svg>
  );
}

export function PlusIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M 9 3 L 9 15 M 3 9 L 15 9" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  );
}

export function ChevronIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M 6 4 L 11 8 L 6 12" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function BackIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path d="M 9 2 L 4 7 L 9 12" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function ArrowUp() {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12">
      <path d="M 2 7 L 6 3 L 10 7" stroke="#000" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function ArrowDown() {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12">
      <path d="M 2 5 L 6 9 L 10 5" stroke="#000" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function CrossIcon() {
  return (
    <svg width="10" height="10" viewBox="0 0 12 12">
      <path d="M 2 2 L 10 10 M 10 2 L 2 10" stroke="#000" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function MoreIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <circle cx="3" cy="8" r="1.6" fill="currentColor" />
      <circle cx="8" cy="8" r="1.6" fill="currentColor" />
      <circle cx="13" cy="8" r="1.6" fill="currentColor" />
    </svg>
  );
}

export function ShareIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <circle cx="12" cy="3.5" r="2" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="4" cy="8" r="2" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="12" cy="12.5" r="2" stroke="currentColor" strokeWidth="1.8" />
      <path d="M 5.7 7 L 10.3 4.5 M 5.7 9 L 10.3 11.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

export function EyeIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
      <path d="M 1.5 8 C 3 4.5 5.4 3 8 3 C 10.6 3 13 4.5 14.5 8 C 13 11.5 10.6 13 8 13 C 5.4 13 3 11.5 1.5 8 Z" stroke="#000" strokeWidth="1.6" strokeLinejoin="round" />
      <circle cx="8" cy="8" r="2.2" stroke="#000" strokeWidth="1.6" />
    </svg>
  );
}

export function RotateIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 14 14" fill="none">
      <path d="M 2 7 a 5 5 0 1 0 1.5 -3.5" stroke="#000" strokeWidth="1.6" fill="none" strokeLinecap="round" />
      <path d="M 2 2 L 2 5 L 5 5" stroke="#000" strokeWidth="1.6" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function RetryIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 14 14" fill="none">
      <path d="M 12 7 a 5 5 0 1 1 -1.5 -3.5" stroke="#000" strokeWidth="1.6" fill="none" strokeLinecap="round" />
      <path d="M 12 2 L 12 5 L 9 5" stroke="#000" strokeWidth="1.6" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function PaperStack() {
  return (
    <svg width="120" height="80" viewBox="0 0 120 80">
      <rect x="22" y="14" width="50" height="58" rx="3" fill="var(--tp-surface)" stroke="var(--tp-ink)" strokeWidth="2" transform="rotate(-8 47 43)" />
      <rect x="48" y="10" width="50" height="58" rx="3" fill="var(--tp-surface)" stroke="var(--tp-ink)" strokeWidth="2" transform="rotate(6 73 39)" />
      <rect x="35" y="14" width="50" height="58" rx="3" fill="var(--tp-surface)" stroke="var(--tp-ink)" strokeWidth="2" />
      <path d="M 48 30 L 72 30 M 48 38 L 68 38 M 48 46 L 70 46 M 48 54 L 64 54" stroke="var(--tp-ink-soft)" strokeWidth="1.5" strokeLinecap="round" opacity="0.5" />
    </svg>
  );
}

export function Sparkler() {
  return (
    <svg width="100" height="100" viewBox="0 0 100 100">
      <circle cx="50" cy="50" r="32" fill="var(--tp-accent3)" stroke="var(--tp-ink)" strokeWidth="3" />
      <path d="M 50 30 L 53 45 L 68 48 L 53 51 L 50 66 L 47 51 L 32 48 L 47 45 Z" fill="var(--tp-surface)" stroke="var(--tp-ink)" strokeWidth="2.5" strokeLinejoin="round" />
      <circle cx="22" cy="22" r="3" fill="var(--tp-accent)" />
      <circle cx="80" cy="28" r="2.5" fill="var(--tp-accent2)" />
      <circle cx="84" cy="74" r="3.5" fill="var(--tp-accent)" />
      <circle cx="18" cy="78" r="2.5" fill="var(--tp-accent2)" />
    </svg>
  );
}
